import { BodyLink } from '@jouzen/ecom-components/v3/BodyLink';
import { List } from '@jouzen/ecom-components/v3/List';
import { ListItem } from '@jouzen/ecom-components/v3/ListItem';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import { Fragment } from 'react';

import RichText from '@/app/components/RichText';

import type { TCSectionData } from './types';

const TCSection = ({
  title,
  paragraphs,
  listItems,
  endParagraphs,
}: TCSectionData) => {
  const t = useTranslations();

  return (
    <>
      {title && (
        <Typography Element="h3" variant="h3">
          {t(title)}
        </Typography>
      )}

      {paragraphs.map(({ id, paragraph, links }) => {
        const linkObj = links?.reduce((acc, link) => {
          const { localiseKey, href, skipLocalisedString, text } = link;
          return {
            ...acc,
            [localiseKey]: (
              <BodyLink
                key={`${id}-link-${href}`}
                color="inherit"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                {skipLocalisedString ? text : t(text)}
              </BodyLink>
            ),
          };
        }, {});

        return (
          <Fragment key={id}>
            {!links && <Typography>{t(paragraph)}</Typography>}
            {linkObj && (
              <Typography>
                <RichText messageKey={paragraph} tValues={linkObj} />
              </Typography>
            )}
          </Fragment>
        );
      })}

      {listItems && (
        <List Element="ul">
          {listItems.map(({ id, text }) => (
            <ListItem key={id}>{t(text)}</ListItem>
          ))}
        </List>
      )}

      {endParagraphs?.map(({ id, paragraph }) => (
        <Typography key={id}>{t(paragraph)}</Typography>
      ))}
    </>
  );
};

export default TCSection;
